import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Button from "~/shared/ui/Fields/Button";
import Wrapper from "~/shared/ui/Wrapper";
import { usePermissions } from "~/shared/context/PermissionContext";

import { options } from "./options";

import s from "./EditorCatalogEducationalPrograms.less";

const EditorCatalogEducationalPrograms = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const goBack = () => history.replace("/editor/");
  const { hasPermission, loading: loadingPermissions } = usePermissions();

  const allowedOptions = options.filter((item) =>
    hasPermission(item.permission),
  );
  return (
    <Wrapper.Content
      title={t("cep.catalogEducationalPrograms")}
      txtBtn={t("ui.back")}
      goBackHandler={goBack}
    >
      <div className={s.wrapper_editor}>
        <div className={s.wrapper_items}>
          {allowedOptions.map((item) => {
            return (
              <div className={s.item} key={item.id}>
                <div className={s.item__content}>
                  <div className={s.item__title}>
                    {t(`cep.${item.description_lang_key}`)}
                  </div>
                </div>
                <div className={s.button}>
                  <Button
                    txtBtn={t("cep.button_go")}
                    orange
                    onClick={() => history.push(item.path)}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Wrapper.Content>
  );
};

export default EditorCatalogEducationalPrograms;
